import { normalizeGtfsStartDate } from "./tripIds";

function normalizeFerryStartDate(startDate) {
  return normalizeGtfsStartDate(String(startDate || "").replace(/-/g, ""));
}

export function getLiveFerryTripHref({ tripId, startDate }) {
  const encodedTripId = encodeURIComponent(tripId);
  const normalizedStartDate = normalizeFerryStartDate(startDate);

  if (!normalizedStartDate) {
    return `/trip/${encodedTripId}?from=ferry`;
  }

  const date = `${normalizedStartDate.slice(0, 4)}-${normalizedStartDate.slice(
    4,
    6,
  )}-${normalizedStartDate.slice(6, 8)}`;

  return `/trip/${encodedTripId}?from=ferry&date=${date}`;
}

export function getLiveFerryStartDate(startDate) {
  return normalizeFerryStartDate(startDate);
}
